module.exports = __webpack_public_path__ + "img/updated_framework.fb6c3fed.png";